export const change_price_based_on_discount_table = (passed_variation, voucher) => {
    if (passed_variation.stock_item_discount_table) {
        // sort the array descending, so that when I use findIndex it gets the largest number applicable
        var key_checker = Object.keys(passed_variation.stock_item_discount_table).sort((a, b) => b - a)
        // the quantity we want to add to our basket

        // check the object for our quantity
        var match = key_checker.findIndex((element) => element <= passed_variation.add_quantity)

        if (match >= 0) {
            var key = key_checker[match]
            // overwrite the values here
            passed_variation.price = passed_variation.stock_item_discount_table[key].price
            passed_variation.price_ex_vat = passed_variation.stock_item_discount_table[key].price_ex_vat
            passed_variation.price_inc_vat = passed_variation.stock_item_discount_table[key].price_inc_vat
            // unset the discount, as its not been discounted if its been overwritten
            passed_variation.dis = null
        }
    }

    // add in here the vouchers checks - only if the variation is not already dicounted
    if (voucher && voucher[0] && voucher[0].data && passed_variation.dis == null) {
        // we have a voucher, logic goes here
        if (passed_variation.original_price == null) {
            passed_variation.original_price = passed_variation.price
            passed_variation.original_price_ex_vat = passed_variation.price_ex_vat
            passed_variation.original_price_inc_vat = passed_variation.price_inc_vat
        }

        if (voucher[0].data.discount_products.length > 0) {
            // check if our passed_variation.parent_id exists in the product_discounts array
            var voucher_match = voucher[0].data.discount_products.findIndex((element) => element.id == passed_variation.product_id)
            if (voucher_match >= 0) {
                // we have a match
                // reverse calculate the VAT rate for use later
                var vat_rate = passed_variation.price_inc_vat / passed_variation.price
                // check what kind of discount it is and modify the prices accordingly
                if (voucher[0].data.discount_amount != null) {
                    passed_variation.price = passed_variation.price - voucher[0].data.discount_amount
                    passed_variation.price_ex_vat = passed_variation.price
                    passed_variation.price_inc_vat = passed_variation.price * vat_rate
                    passed_variation.dis = voucher[0].data.code
                } else if (voucher[0].data.discount_percentage != null) {
                    passed_variation.price = passed_variation.price * (1 - (voucher[0].data.discount_percentage / 100))
                    passed_variation.price_ex_vat = passed_variation.price
                    passed_variation.price_inc_vat = passed_variation.price * vat_rate
                    passed_variation.dis = voucher[0].data.code
                }
              
            }
        } else if (voucher[0].data.discount_taxonomies.length > 0) {

            // not limited by product, check taxonomies first
            if (passed_variation.parent_taxonomy_ids) {
                passed_variation.parent_taxonomy_ids.map((parent_taxonomy_id) => {
                    var voucher_tax_match = voucher[0].data.discount_taxonomies.findIndex((element) => element.id == parent_taxonomy_id)
                    if (voucher_tax_match >= 0 && passed_variation.dis == null) {
                        // we have a match
                        // reverse calculate the VAT rate for use later
                        var vat_rate = passed_variation.price_inc_vat / passed_variation.price
                        // check what kind of discount it is and modify the prices accordingly
                        if (voucher[0].data.discount_amount != null) {
                            passed_variation.price = passed_variation.price - voucher[0].data.discount_amount
                            passed_variation.price_ex_vat = passed_variation.price
                            passed_variation.price_inc_vat = passed_variation.price * vat_rate
                            passed_variation.dis = voucher[0].data.code
                        } else if (voucher[0].data.discount_percentage != null) {
                            passed_variation.price = passed_variation.price * (1 - (voucher[0].data.discount_percentage / 100))
                            passed_variation.price_ex_vat = passed_variation.price
                            passed_variation.price_inc_vat = passed_variation.price * vat_rate
                            passed_variation.dis = voucher[0].data.code
                        }
                        
                    }
                })
            }
        }  else if (voucher[0].data.discount_products_exclude.length > 0) {
            // check if our passed_variation.parent_id exists in the discount_products_exclude array
            var voucher_match = voucher[0].data.discount_products_exclude.findIndex((element) => element.id == passed_variation.product_id)
            if (voucher_match < 0) {
                // we dont have a match
                // reverse calculate the VAT rate for use later
                var vat_rate = passed_variation.price_inc_vat / passed_variation.price
                // check what kind of discount it is and modify the prices accordingly
                if (voucher[0].data.discount_amount != null) {
                    passed_variation.price = passed_variation.price - voucher[0].data.discount_amount
                    passed_variation.price_ex_vat = passed_variation.price
                    passed_variation.price_inc_vat = passed_variation.price * vat_rate
                    passed_variation.dis = voucher[0].data.code
                } else if (voucher[0].data.discount_percentage != null) {
                    passed_variation.price = passed_variation.price * (1 - (voucher[0].data.discount_percentage / 100))
                    passed_variation.price_ex_vat = passed_variation.price
                    passed_variation.price_inc_vat = passed_variation.price * vat_rate
                    passed_variation.dis = voucher[0].data.code
                }
            }
        } else if (voucher[0].data.discount_taxonomies_exclude.length > 0) {
            // not limited by product, check taxonomies first
            if (passed_variation.parent_taxonomy_ids) {
                var isTaxFound = false;
                passed_variation.parent_taxonomy_ids.map((parent_taxonomy_id) => {
                    var voucher_tax_match = voucher[0].data.discount_taxonomies_exclude.findIndex((element) => element.id != parent_taxonomy_id)
                    if (voucher_tax_match < 0 && passed_variation.dis == null) {
                        isTaxFound = true;
                    }
                })
                if(!isTaxFound){
                     // we have a match
                    // reverse calculate the VAT rate for use later
                    var vat_rate = passed_variation.price_inc_vat / passed_variation.price
                    // check what kind of discount it is and modify the prices accordingly
                    if (voucher[0].data.discount_amount != null) {
                        passed_variation.price = passed_variation.price - voucher[0].data.discount_amount
                        passed_variation.price_ex_vat = passed_variation.price
                        passed_variation.price_inc_vat = passed_variation.price * vat_rate
                        passed_variation.dis = voucher[0].data.code
                    } else if (voucher[0].data.discount_percentage != null) {
                        passed_variation.price = passed_variation.price * (1 - (voucher[0].data.discount_percentage / 100))
                        passed_variation.price_ex_vat = passed_variation.price
                        passed_variation.price_inc_vat = passed_variation.price * vat_rate
                        passed_variation.dis = voucher[0].data.code
                    }
                }
            }
        } else {
            // not limited by products or taxonomies, its a free for all products
            // reverse calculate the VAT rate for use later
            var vat_rate = passed_variation.price_inc_vat / passed_variation.price
            // check what kind of discount it is and modify the prices accordingly
            if (voucher[0].data.discount_amount != null) {
                passed_variation.price = passed_variation.price - voucher[0].data.discount_amount
                passed_variation.price_ex_vat = passed_variation.price
                passed_variation.price_inc_vat = passed_variation.price * vat_rate
                passed_variation.dis = voucher[0].data.code
            } else if (voucher[0].data.discount_percentage != null) {
                passed_variation.price = passed_variation.price * (1 - (voucher[0].data.discount_percentage / 100))
                passed_variation.price_ex_vat = passed_variation.price
                passed_variation.price_inc_vat = passed_variation.price * vat_rate
                passed_variation.dis = voucher[0].data.code
            }
           
        }
    } else if (!voucher || (voucher && !voucher[0])) {
        // set back to the original prices
        if (passed_variation.original_price != null) {
            passed_variation.price = passed_variation.original_price
            passed_variation.price_ex_vat = passed_variation.original_price_ex_vat
            passed_variation.price_inc_vat = passed_variation.original_price_inc_vat
            passed_variation.original_price = null
            passed_variation.original_price_ex_vat = null
            passed_variation.original_price_inc_vat = null
            // set the discount tracker back to null
            passed_variation.dis = null
        }
    }
    return passed_variation
}
